// extracted by mini-css-extract-plugin
export default {"logo-print":"jyn6QxI___logo-print","logoPrint":"jyn6QxI___logo-print","logo-print-by":"dVVgLmB___logo-print-by","logoPrintBy":"dVVgLmB___logo-print-by"};